import { createSlice } from '@reduxjs/toolkit';
import { SiteDirector } from 'types';

export interface InitialState {
  unapproved: {
    loading: boolean;
    sites: SiteDirector[];
    total: number;
  };
}

const initialState: InitialState = {
  unapproved: {
    loading: true,
    sites: [],
    total: 0,
  },
};

export const homeSlice = createSlice({
  name: 'home-page',
  initialState,
  reducers: {},
  extraReducers(builder) {},
});

export default homeSlice.reducer;
